import { HTMLAttributes } from 'react';
import { ExistentMetaInfoViewStatus } from './types';
import { viewStatusLabels, getViewStatusLabel } from './viewStatusLabels';
import { viewStatusBrands } from './viewStatusBrands';
import { Tag } from '@ardoq/status-ui';
import styled from 'styled-components';
import { type I18nLocale } from '@ardoq/i18n';

type ViewStatusTextBadgeProperties = {
  viewStatus: ExistentMetaInfoViewStatus;
  i18nLocale?: I18nLocale;
} & HTMLAttributes<HTMLSpanElement>;

const TagWrapper = styled.span`
  display: flex;
  align-items: center;
`;

const ViewStatusTextBadge = ({
  viewStatus,
  i18nLocale,
  ...props
}: ViewStatusTextBadgeProperties) => (
  <TagWrapper {...props}>
    <Tag
      statusType={viewStatusBrands[viewStatus]}
      label={
        i18nLocale
          ? getViewStatusLabel(i18nLocale, viewStatus)
          : viewStatusLabels[viewStatus]
      }
    />
  </TagWrapper>
);

export { ViewStatusTextBadge };
